
// ------------------ validate files --------------
const filesBlockDiv = '.form-upload'
let $fileInputs = $('input[type=file]')
let fileListArr = []
let msgDiv = '.file-msg'
let addedFilesDiv = '.selected-files' // added files list
let maxFileSize = 8 // mb
let maxTotSize = 8
let maxFiles = 8
let extArr = ['jpeg','jpg','png','pdf', 'docx', 'doc', 'edoc']
let fileTooLarge = 'Faila izmērs ir pārāk liels!'
let typeNotAllowed = 'Faila tips nav atļauts!'
let tooManyFiles = 'Maksimālais failu skaits ir '+maxFiles
let totSizeMsg = 'Pārsniegts maksimālais kopējais izmērs '+maxTotSize
let removeFile = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 4L4 12" stroke="#824216" stroke-width="1.6" stroke-linecap="round"/><path d="M4 4L12 12" stroke="#824216" stroke-width="1.6" stroke-linecap="round"/> </svg>\n'



  $('body').on( 'change', 'input[type=file]', function( e ){
    let filec = $(this).parent()
    let inputId = $(this).attr('id')
    var addedFiles = filec.find(addedFilesDiv)
    let msg = filec.find(msgDiv)
    let fileList = []
    let validateFile = 1
    let filesCount = 0
    let totSize = 0

    console.log('file')

    $(addedFiles).empty()
    msg.html('')

    for (let i = this.files.length - 1; i >= 0; i--) {
      filesCount++
      let fileErr = ''
      let addFileToList = 1

      // check file size
      let size = this.files[i].size / 1024 / 1024
      totSize = totSize + size
      if (size > maxFileSize) {
        validateFile = 0
        addFileToList = 0
        //msg.append(fileTooLarge);
        fileErr = fileTooLarge
      }

      // file types
      let ext = this.files[i].name.split('.').pop().toLowerCase()
      if($.inArray(ext, extArr) == -1) {
        validateFile = 0
        addFileToList = 0
        //msg.append(typeNotAllowed);
        fileErr = typeNotAllowed
      }

      // files count
      if (filesCount > maxFiles){
        validateFile = 0
        addFileToList = 0
        fileErr = tooManyFiles
      }

      // file tot size
      if (totSize >= maxTotSize){
        validateFile = 0
        addFileToList = 0
        fileErr = totSizeMsg
      }

      // add to list if allowed
      if (addFileToList === 1){
        fileList.push(this.files[i])
        addedFiles.append('<div class="uploaded-file">'+this.files[i].name+'<span class="remove" data-el="'+this.files[i].name+'" >'+removeFile+'</span></div>')
      } else {
        addedFiles.append('<div class="uploaded-file error">'+this.files[i].name+' <span> - '+fileErr+'</span</div>')
      }
    }

    fileListArr[inputId] = {'files':'', 'validated':0}
    fileListArr[inputId]['files'] = fileList
    fileListArr[inputId]['validated'] = validateFile

  });



// remove file
$(document).on('click','.uploaded-file span',function(){
  var inputId = $(this).closest(filesBlockDiv).find('input[type="file"]').attr('id')
  var remel = $(this).attr('data-el')
  fileListArr[inputId]['files'].splice( fileListArr[inputId]['files'].indexOf(remel), 1 )
  $(this).parent().remove()
});

